import { api } from './client';
import type { PresenceDto } from './types';

export function getPresence(userId: string): Promise<PresenceDto> {
  return api<PresenceDto>(`/api/v1/users/${userId}/presence`);
}
